import React, { useRef, useState } from "react";

import AuthService from "../services/auth.service";
import CheckButton from "react-validation/build/button";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import i18n from '../i18n';
import { isEmail } from "validator";
import toast from "react-hot-toast";
import { useTranslation } from 'react-i18next';

const required = (value) => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        {i18n.t('auth.fieldRequired')}
      </div>
    );
  }
};

const validEmail = (value) => {
  if (!isEmail(value)) {
    return (
      <div className="alert alert-danger" role="alert">
        {i18n.t('auth.invalidEmail')}
      </div>
    );
  }
};

const vusername = (value) => {
  if (value.length < 3 || value.length > 20) {
    return (
      <div className="alert alert-danger" role="alert">
        {i18n.t('auth.usernameLength')}
      </div>
    );
  }
};

const vpassword = (value) => {
  if (value.length < 6 || value.length > 40) {
    return (
      <div className="alert alert-danger" role="alert">
        {i18n.t('auth.passwordLength')}
      </div>
    );
  }
};

const Register = () => {
  const { t } = useTranslation();
  const form = useRef();
  const checkBtn = useRef();

  // react-validation passes (value, props, components); compare with the password field.
  const vrepeatPassword = (value, props, components) => {
    const pwd = components && components.password && components.password[0];
    if (pwd && value !== pwd.value) {
      return (
        <div className="alert alert-danger" role="alert">
          {t('auth.passwordMismatch')}
        </div>
      );
    }
  };

  const currentUser = AuthService.getCurrentUser();
  const isAdmin = !!(currentUser && (currentUser.roles || []).includes("ROLE_ADMIN"));

  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  const [role, setRole] = useState("user");
  const [successful, setSuccessful] = useState(false);
  const [message, setMessage] = useState("");

  const onChangeUsername = (e) => {
    const username = e.target.value;
    setUsername(username);
  };

  const onChangeEmail = (e) => {
    const email = e.target.value;
    setEmail(email);
  };

  const onChangePassword = (e) => {
    const password = e.target.value;
    setPassword(password);
  };

  const onChangeRole = (e) => {
    setRole(e.target.value);
  };

  const handleRegister = (e) => {
    e.preventDefault();

    setMessage("");
    setSuccessful(false);

    form.current.validateAll();

    if (password !== repeatPassword) {
      toast.error(t('auth.passwordMismatch'));
      return;
    }

    if (checkBtn.current.context._errors.length === 0) {
      AuthService.register(username, email, password, [role], repeatPassword).then(
        (response) => {
          setMessage(t('auth.registerSuccess'));
          setSuccessful(true);
        },
        (error) => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();

          toast.error(resMessage);
          setSuccessful(false);
        }
      );
    }
  };

  return (
    <div className="col-md-12 mt-5">
      <div className="card card-container col-md-6 mx-auto p-5">
        <h3 className="text-center mb-4">{t('nav.register')}</h3>

        <Form onSubmit={handleRegister} ref={form}>
          {!successful && (
            <div>
              <div className="form-group mt-3">
                <label htmlFor="username">{t('auth.username')}</label>
                <Input
                  type="text"
                  className="form-control"
                  name="username"
                  value={username}
                  onChange={onChangeUsername}
                  validations={[required, vusername]}
                />
              </div>
  
              <div className="form-group mt-3">
                <label htmlFor="email">{t('auth.email')}</label>
                <Input
                  type="text"
                  className="form-control"
                  name="email"
                  value={email}
                  onChange={onChangeEmail}
                  validations={[required, validEmail]}
                />
              </div>

              <div className="form-group mt-3">
                <label htmlFor="password">{t('auth.password')}</label>
                <Input
                  type="password"
                  className="form-control"
                  name="password"
                  value={password}
                  onChange={onChangePassword}
                  validations={[required, vpassword]}
                />
              </div>

              <div className="form-group mt-3">
                <label htmlFor="repeatPassword">{t('auth.repeatPassword')}</label>
                <Input
                  type="password"
                  className="form-control"
                  name="repeatPassword"
                  value={repeatPassword}
                  onChange={(e) => setRepeatPassword(e.target.value)}
                  validations={[required, vrepeatPassword]}
                />
              </div>

              {isAdmin && (
                <div className="form-group mt-3">
                  <label htmlFor="role">{t('auth.role')}</label>
                  <select
                    id="role"
                    className="form-select"
                    value={role}
                    onChange={onChangeRole}
                  >
                    <option value="user">{t('auth.roleUser')}</option>
                    <option value="moderator">{t('auth.roleModerator')}</option>
                    <option value="admin">{t('auth.roleAdmin')}</option>
                  </select>
                </div>
              )}

              <div className="form-group mt-4">
                <button className="btn btn-primary btn-block">{t('auth.signUp')}</button>
              </div>
            </div>
          )}

          {message && (
            <div className="form-group mt-4">
              <div
                className={ successful ? "alert alert-success" : "alert alert-danger" }
                role="alert"
              >
                {message}
              </div>
            </div>
          )}
          <CheckButton style={{ display: "none" }} ref={checkBtn} />
        </Form>
      </div>
    </div>
  );
};

export default Register;